import { type FC, useEffect } from 'react';

import { AlertDetails } from '@/alerts/view/components/alert-details';
import { AlertResetsBanner } from '@/alerts/view/components/alert-resets-banner';
import { AlertsFilters } from '@/alerts/view/components/alerts-filters';
import { AlertsSidebar } from '@/alerts/view/components/alerts-sidebar';
import { useAlertsData } from '@/alerts/view/hooks/use-alerts-data';
import { useAlertsNavigation } from '@/alerts/view/hooks/use-alerts-navigation';
import { FullPageContent } from '@/components/layout/full-page-content';

export const AlertsOverviewPage: FC = () => {
  const {
    alerts,
    alertResets,
    filteredAlerts,
    filters,
    setFilters,
    isLoading,
    isSidebarEmpty,
    handleSidebarNonEmpty,
  } = useAlertsData();

  const { fullFrontendId, type, level, clearSelection, selectAlert } =
    useAlertsNavigation();

  const selectedAlert = alerts?.find(
    (alert) =>
      alert.fullFrontendId === fullFrontendId &&
      alert.type === type &&
      alert.level === level,
  );

  useEffect(
    function () {
      if (
        isSidebarEmpty &&
        (fullFrontendId !== undefined ||
          type !== undefined ||
          level !== undefined)
      ) {
        clearSelection();
      }
    },
    [fullFrontendId, isSidebarEmpty, level, type, clearSelection],
  );

  const handleAlertSelect = (alert: any) => {
    selectAlert(alert);
    handleSidebarNonEmpty();
  };

  return (
    <FullPageContent
      className="grid h-full grid-rows-[min-content_1fr] overflow-hidden"
      testId="alerts-page"
    >
      <AlertsFilters
        filters={filters}
        onChange={(newFilters) => setFilters(newFilters)}
      />
      <div className="grid h-full grid-cols-[minmax(theme(spacing.60),theme(spacing.96))_1fr] overflow-hidden">
        <div className="h-full overflow-hidden border-r border-gray-200 xl:border-l">
          <AlertResetsBanner alertResets={alertResets} />

          <AlertsSidebar
            selectedId={fullFrontendId}
            selectedType={type}
            selectedLevel={level}
            filters={filters}
            isLoading={isLoading}
            alerts={filteredAlerts}
            onSelect={handleAlertSelect}
          />
        </div>
        {!isSidebarEmpty ? <AlertDetails alert={selectedAlert} /> : null}
      </div>
    </FullPageContent>
  );
};
